import { useEffect, useRef } from "react";
import useSWR from "swr";

import { SWRType } from "../types/global";
import { authFetcher } from "../utils/auth-fetch";

const useDashboard = (autoFetch = false, props: Record<string, any> = {}) => {
  const swrUrl = "dashboard";
  const retryCountRef = useRef(0);

  const {
    data,
    isLoading: dataLoading,
    mutate,
    error,
  }: SWRType = useSWR(
    autoFetch ? [swrUrl, props] : null,
    ([url, queryParams]) =>
      authFetcher("GET", url, null, queryParams, {
        "Content-Type": "application/json",
      }),
    {
      refreshInterval: 20000,
      // onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
      //   if (error.status === 404) return;
      //   if (error.status === 408) {
      //     // Retry up to 5 times for 408 errors
      //     if (retryCount < 5) {
      //       setTimeout(() => revalidate({ retryCount: retryCount + 1 }), 2000);
      //     }
      //   }
      // },
      onErrorRetry: (error, _key, _config, revalidate) => {
        if (error.status === 404) return;
        if (error.status === 408) {
          if (retryCountRef.current < 5) {
            retryCountRef.current += 1;
            setTimeout(() => revalidate({}), 3000);
          }
        }
      },
    },
  );

  useEffect(() => {
    if (data) {
      retryCountRef.current = 0;
    }

    return () => {
      retryCountRef.current = 0;
    };
  }, [data]);

  return { data, dataLoading, mutate, error };
};

export default useDashboard;
